/**
 * Labstep
 *
 * @module screens/Experiment/Print
 * @desc Display printable version of an Experiment
 */

import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import Print from 'labstep-web/core/Print';
import { EntityExport } from 'labstep-web/models/entity-export.model';
import { Experiment } from 'labstep-web/models/experiment.model';
import type React from 'react';
import type { IExperimentPrintScreenProps } from './types';

export const ExperimentPrintScreen: React.FC<
  IExperimentPrintScreenProps
> = ({ match }) => (
  <EntityCreateContainer entityName={EntityExport.entityName}>
    {({ status, create }) => (
      <Print
        id={match.params.id}
        entityName={Experiment.entityName}
        status={status}
        create={create}
      />
    )}
  </EntityCreateContainer>
);
